























import { Vue, Prop, Component, Ref, Watch } from "vue-property-decorator";
import lectures, { LectureListParams } from "@/getinfo-api/lectures";
import { Lecture as ILecture } from "@/api/models/lecture";
import { LecturesList as ILecturesList } from "@/api/models/lectures-list";
import CustomButton from "@/components/form/CustomButton.vue";
import { CourseLectureCreate as ICourseLectureCreate } from "@/api/models/course-lecture-create";
import api from "@/getinfo-api";
import CSingleSelect from "@/components/form/CSingleSelect.vue";

@Component({
  components: { CSingleSelect, CustomButton }
})
export default class AttachLectureToCourse extends Vue {
  @Prop() courseId!: string;
  @Prop() companyId!: string;
  @Prop() existLecturesIds?: Array<string> | undefined;
  @Ref("search") search: any;
  disableButton: boolean = false;
  selectedLectureId: string = "";
  lectures: Array<ILecture> = [];
  lecturesCount: number = 0;
  offset: number = 0;
  isLectureLoading: boolean = false;
  searchLectureTitle: string = "";
  unset: boolean = false;

  get filteredLectures() {
    return this.lectures.filter(el => {
      return !this.existLecturesIds?.includes(el.id);
    });
  }

  update() {
    this.unset = false;
  }

  async attachLecture() {
    this.update();
    if (this.selectedLectureId) {
      this.disableButton = true;
      let params: ICourseLectureCreate = {
        lectureId: this.selectedLectureId,
        sort: (this.existLecturesIds?.length ?? 0) + 1 ?? 90
      };
      try {
        await api.CourseLectureApi.create(this.courseId, params);
      } catch (err) {
        await this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      } finally {
        this.disableButton = false;
        this.unset = true;
      }

      this.$emit("updateLecture");
      this.selectedLectureId = "";
    } else {
      await this.$store.dispatch(
        "localError",
        this.$tc(this.$translate.ChooseAtLeastOneCourse)
      );
    }
  }

  searchLectureByTitle(title: string) {
    this.lectures = [];
    this.searchLectureTitle = title;
    this.offset = 0;
    this.getLectureList(0);
  }

  showMore() {
    if (this.lecturesCount > this.filteredLectures?.length) {
      this.offset += 30;
      this.getLectureList(this.offset);
    }
  }

  getLectureList(offset: number = 0) {
    this.isLectureLoading = true;
    const params: LectureListParams = {
      companyId: this.companyId,
      title: this.searchLectureTitle ?? undefined,
      offset: offset,
      limit: 30,
      order: "DESC",
      sort: "updatedAt"
    };
    lectures(params)
      .then((res: { data: ILecturesList }) => {
        this.lecturesCount = res.data.count;
        this.lectures = [...this.lectures, ...res.data.lectures];
      })
      .finally(() => {
        this.isLectureLoading = false;
      });
  }

  created() {
    this.getLectureList();
  }
}
